export default class SaleHandoverQuestionsViewModel {
    clientId: number = 0;
    userId: string = '';
    overview: string = '';
    goal: string = '';
    linkedInPresence: string = '';
    upsellOpportunities: string = '';
    packageCustomisation: string = '';
}